class MainSearch extends SearchForm {
  constructor() {
    super();

    this.allSearchInputs = document.querySelectorAll('input[data-main-search-input]');

    this.clearButton = this.querySelector('[data-main-search-clear]');
    this.searchInput = this.querySelector('[data-main-search-input]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.handleClearClick.bind(this));
    }

    const allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  handleClearClick() {
    this.searchInput.value = '';

    this.searchInput.focus();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const { target } = event;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
